import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

import { renderToastWarn } from 'utils/ToastUtils'
import { ToastContainer } from 'react-toastify'
import Breadcrumb from 'component/Breadcrumb'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import FilterForm from 'component/usageConsumption/FilterForm'
import Grid from 'component/utils/Grid'
import Notification from 'component/utils/Notification'
import Pagination from 'component/pagination/Pagination'
import SideFilterForm from 'component/usageConsumption/SideFilterForm'
import Table from 'component/usageConsumption/Table'
import Title from 'component/usageConsumption/Title'

import * as usageConsumptionReportActions from 'action/usageConsumptionReport'
import * as reportActions from 'action/report' 
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

const ALL_STORES_USER = '999'

const USAGE_CONSUMPTION_REPORT_CSV = 21

const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 1,
  size: 10,
}

const DEFAULT_INITIAL_VALUES = {
  branchIdList: [],
  cdLm: '',
  destinyList: [],
  dtEnd: null,
  dtStart: null,
  originList: [],
  sectionIdList: [],
}

const UsageConsumptionReport = ({
  auth,
  auth: {
    user: { locationCode, dsToken, title },
  },
  count,
  current,
  error,
  fetch,
  fetchUsageConsumptionStatus,
  fetchFluxReport,
  list,
  pages,
  statusList,
  translate,
}) => {
  const headerRef = useRef(null)
  const tableRef = useRef(null)

  const [filters, setFilters] = useState({})
  const [initialValues, setInitialValues] = useState(DEFAULT_INITIAL_VALUES)
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [showTable, setShowTable] = useState(false)
  const [sideFilterElement, setSideFilterElement] = useState(null)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [missionsSelectBranchs, setMissionsSelectBranchs] = useState([])
  // Did mount
  useEffect(() => {
    window.addEventListener('resize', handleResize)
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }
    getParameter(params)
    fetchUsageConsumptionStatus(dsToken)

  }, [])

  // When error changes
  useEffect(() => {
    if (error) renderToastWarn(error)
  }, [error])

  // When filters change
  useEffect(() => {
    handleResize()

    if (showTable) {
      const param = {
        ...filters,
        ...pagination,
        page: 1,
      }

      fetch(dsToken, param)
    }
  }, [filters])

  // When pagination changes
  useEffect(() => {
    handleResize()

    if (showTable) {
      const param = {
        ...filters,
        ...pagination,
      }

      fetch(dsToken, param)
    }
  }, [pagination])

  // Will unmount
  useEffect(() => () => window.removeEventListener('resize', handleResize))

  const handleFetch = (filters) => {
    const { initialValues } = filters

    setFilters(filters)
    setInitialValues(initialValues)
    setShowTable(true)
    handleFilterCollapseChange(false)
  }

  const handlePagination = (page) => {
    setPagination({ ...pagination, page })

    handleFetch(filters)
  }

  const getParameter = (values) => new Api(dsToken)
    .get(API_URL.PARAMETER_GET, values)
    .then(resp => setMissionsSelectBranchs(resp.data.split(",")))

  const handleResize = () => {}

  const renderBreadcrumb = () => {
    const steps = [
      { title: translate('mobile.home'), link: '/' },
      {
        title: translate('menu.usage.consumption.2'),
        callback: () => setShowTable(false),
      },
      { title: translate('mobile.report'), strong: true },
    ]

    return <Breadcrumb steps={steps} />
  }

  const renderPagination = () => {
    if (pages < 2) {
      return
    }

    return (
      <Col className='align-center rupture-irc-pagination'>
        <Pagination
          count={count}
          current={current}
          getPage={handlePagination}
          pages={pages}
        />
      </Col>
    )
  }

  const handleFilterCollapseChange = (sideFilterVisible) => {
    setSideFilterVisible(sideFilterVisible)
  }

  const exportCsv = () => {
    const abortController = new AbortController()
  
    const newFilters = {...filters}
    if (typeof newFilters.statusType === 'undefined') {
      delete newFilters.statusType;
    }
   
     newFilters.dtStart =  newFilters.dtStart.toISOString()
     newFilters.dtEnd = newFilters.dtEnd.toISOString()
    fetchFluxReport(
      dsToken,
      { tpReport: USAGE_CONSUMPTION_REPORT_CSV },
      newFilters,
      translate,
      abortController
    )
  }

  return (
    <div className='stock-adjustment'>
      <div
        ref={headerRef}
        className={showTable ? 'stock-adjustment-header' : ''}
      >
        <ContentHeader>{translate('usage.consumption.report')}</ContentHeader>

        {renderBreadcrumb()}
      </div>

      <div
        className={showTable ? 'stock-adjustment-filter padding-bottom' : ''}
      >
        <Grid fluid>
          <FilterForm
            auth={auth}
            filtersVisible={locationCode === ALL_STORES_USER || missionsSelectBranchs.includes(title)}
            initialValues={initialValues}
            showTable={showTable}
            sideFilterVisible={sideFilterVisible}
            statusList={statusList}
            submit={handleFetch}
            token={auth.user.dsToken}
            translate={translate}
            exportCsv={exportCsv}
          />

          {showTable && (
            <Title
              handleSideFilterMenuCollapseChange={handleFilterCollapseChange}
              sideFilterVisible={sideFilterVisible}
              translate={translate}
            />
          )}
        </Grid>
      </div>

      {showTable && (
        <div ref={tableRef} className='less-padding-top stock-adjustment-table'>
          <Grid fluid className='no-padding'>
            <div className='outer-table'>
              <div className='flex'>
                <SideFilterForm
                  filtersVisible={locationCode === ALL_STORES_USER || missionsSelectBranchs.includes(title)}
                  handleSideFilterElementChange={setSideFilterElement}
                  initialValues={initialValues}
                  sideFilterVisible={sideFilterVisible}
                  statusList={statusList}
                  submit={handleFetch}
                  token={auth.user.dsToken}
                  translate={translate}
                  auth={auth}
                />

                {list.length ? (
                  <div
                    className='margin-top padding-right-double'
                    style={{ paddingLeft: sideFilterVisible ? null : '2rem' }}
                  >
                    <Table
                      auth={auth}
                      handleResize={handleResize}
                      records={list}
                      sideFilterElement={sideFilterElement}
                      sideFilterVisible={sideFilterVisible}
                      topMargin={'0'}
                      translate={translate}
                    />
                  </div>
                ) : (
                  <Col
                    className='margin-top margin-right'
                    style={{ marginLeft: `${sideFilterVisible ? 0.5 : 1}rem` }}
                    xs={12}
                  >
                    <Notification
                      className='notification-warning'
                      message={translate('no.data.found')}
                    />
                  </Col>
                )}
              </div>

              {!!list.length && renderPagination()}
            </div>
          </Grid>
        </div>
      )}

      <ToastContainer newestOnTop />
    </div>
  )
}

UsageConsumptionReport.propTypes = {
  auth: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  error: PropTypes.object,
  fetch: PropTypes.func.isRequired,
  fetchAsyncReports: PropTypes.func.isRequired,
  fetchUsageConsumptionStatus: PropTypes.func.isRequired,
  handleResize: PropTypes.func,
  list: PropTypes.array.isRequired,
  logout: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  pages: PropTypes.number.isRequired,
  statusList: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
  fetchFluxReport: PropTypes.func.isRequired
}

/* istanbul ignore next */
const mapStateToProps = ({ usageConsumptionReducer, paginateReducer }) => ({
  ...usageConsumptionReducer,
  ...paginateReducer,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...usageConsumptionReportActions, ...reportActions },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    UsageConsumptionReport
  )
)

export { UsageConsumptionReport }
